<template>
  <div class="my-toast" v-show="isShow">
    <div class="msg">
      {{ msg }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      isShow: false,
      msg: ""
    }
  },
  methods: {
    show(message, duration = 2000) {
      this.isShow = true;
      this.msg = message;
      setTimeout(() => {
        this.isShow = false;
        this.msg = "";
      }, duration)
    }
  }
}
</script>
<style scoped lang="stylus">
@import '~@assets/stylus/mixin.styl'
.my-toast
  position fixed
  top rpx(524)
  left 50%
  transform translateX(-50%)
  z-index 999
  background rgba(0,0,0,0.7)
  border-radius rpx(16)
  padding rpx(16) rpx(32)
  div.msg
    color #fff
    font-size rpx(28)
    line-height rpx(40)
</style>



// WEBPACK FOOTER //
// src/components/toast/toast.vue